import { AppbarBackButton, ScreenAppbar } from '@/components/atoms';
import { Appbar } from 'react-native-paper';

interface SettingsSubHeaderProps {
  readonly title: string;
  readonly onBack: () => void;
}

export const SettingsSubHeader = ({ title, onBack }: SettingsSubHeaderProps) => {
  return (
    <ScreenAppbar>
      <AppbarBackButton onPress={onBack} />
      <Appbar.Content title={title} />
    </ScreenAppbar>
  );
};
